import React, { lazy, Suspense, memo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Loading from 'components/shared-components/Loading';
import Views from 'views';
import constantsService from 'services/constants';
import { updateConstants } from 'store/slices/constantsSlice';

const AppLayout = lazy(() => import('./AppLayout'));
const AuthLayout = lazy(() => import('./AuthLayout'));

const Layouts = () => {
  const token = useSelector((state) => state.auth.token);
  const blankLayout = useSelector((state) => state.theme.blankLayout);
  const direction = useSelector((state) => state.theme.direction);
  const navType = useSelector((state) => state.theme.navType);
  const navCollapsed = useSelector((state) => state.theme.navCollapsed);
  console.log('token in layout', token, blankLayout)
  const dispatch = useDispatch();

  const Layout = token && !blankLayout ? AppLayout : AuthLayout;
  console.log('layout value', Layout)

  const getConstants = async () => {
    const response = await constantsService.getConstants();
    if (response) {
      dispatch(updateConstants(response))
    }
  }

  useEffect(() => {
    getConstants();
  }, [])

  return (
    <Suspense fallback={<Loading cover='content' />}>
      <Layout
        direction={direction}
        navType={navType}
        navCollapsed={navCollapsed}
      >
        <Views />
      </Layout>
    </Suspense>
  );
};

export default memo(Layouts);
